<template>
  <div class="device-report-tab">
    <border-comp1 v-if="isHisDetail">
      <DeviceReport :isHisDetail="isHisDetail" />
    </border-comp1>
    <border-comp1 v-else>
      <div class="content-class">
        <DeviceReport :reportArray="deviceReport" :clear-report="clearReport" />
      </div>
    </border-comp1>
  </div>
</template>

<script>
import BorderComp1 from '@/components/border-comp1';
import DeviceReport from '@/components/device-report';

export default {
  sockets: {
    '/socket/basic'(res) {
      if (res.sn === this.$route.params.sn) {
        if (this.deviceReport.length > 100) this.deviceReport.splice(this.deviceReport.length / 2);

        res.reportId = this.num++;
        this.deviceReport.unshift(res);
      }
    }
  },
  props: {
    isHisDetail: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DeviceReport,
    BorderComp1
  },
  data() {
    return {
      deviceReport: [],
      num: 1
    };
  },
  methods: {
    clearReport() {
      this.deviceReport.splice(0);
    }
  }
};
</script>

<style lang="scss">
.device-report-tab {
  height: 100%;
  .content-class {
    height: calc(100% - 19px);
  }
}
</style>
